import React from 'react'
import debounceRender from 'react-debounce-render'

import templates from './templates'

import SlidesErrorBoundary from '../SlidesErrorBoundary'

const Template = (props) => {
  const { index, slide, style, audience, deckSignals, Header } = props

  const Component = templates[slide.template]

  return (
    <div className="template" style={style}>
      <Header />
      <SlidesErrorBoundary id={audience._id}>
        <div className="template__outer">
          <div className="template__inner">
            {Component ? (
              <Component
                data={slide.data}
                index={index}
                audience={audience} // required: id; regions (for TopIndexingStates)
                template={slide.template}
                deckSignals={deckSignals}
              />
            ) : (
              <p style={{ fontSize: 24 }}>
                There's no template named <b>{slide.template}</b>
              </p>
            )}
          </div>
        </div>
      </SlidesErrorBoundary>
    </div>
  )
}

export default debounceRender(Template, 500, {
  leading: true,
  maxWait: 1000,
})
